import React, { useState } from "react";
import styles from "./AddStudentsToGroup.module.css";
import SearchBar from "../../components/SearchBar/SearchBar";
import Dropdown from "../../components/Dropdown/Dropdown";
import SaveAndCancel from "../../components/SaveAndCancel/SaveAndCancel";
import ToClose from "../../components/ToClose/ToClose";
import HeadingAndIcon from "../../components/HeadingAndIcon/HeadingAndIcon";
import { FaUserPlus } from "react-icons/fa";
import { useDispatch } from "react-redux";
import { closeModal } from "../../redux/slices/modalSlice";

// ✅ Each student now has a unique ID
const dummyStudents = [
  { id: "s1", name: "John" },
  { id: "s2", name: "Steeve" },
  { id: "s3", name: "John" },
  { id: "s4", name: "Steeve" },
  { id: "s5", name: "John" },
  { id: "s6", name: "Steeve" },
  { id: "s7", name: "John" },
  { id: "s8", name: "Steeve" },
  { id: "s9", name: "John" },
  { id: "s10", name: "Steeve" },
];

const AddStudentsToGroup = () => {
  const dispatch = useDispatch();
  const [selectedStudents, setSelectedStudents] = useState([]);
  const [search, setSearch] = useState("");

  const handleCheckboxChange = (id) => {
    setSelectedStudents((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
    );
  };

  const filteredStudents = dummyStudents.filter((student) =>
    student.name.toLowerCase().includes(search.toLowerCase())
  );
  const handleClose = () => {
    
    dispatch(closeModal());
  };
  const handleSave = () => {
    console.log("Selected:", selectedStudents);
    dispatch(closeModal());
  };

  const handleCancel = () => {
    setSelectedStudents([]); // clear all checkboxes
    setSearch(""); // clear search input
  };

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <HeadingAndIcon icon={<FaUserPlus />} heading="Add Student to group" />
        <ToClose onClose={handleClose} />
      </div>

      <div className={styles.sectionCard}>
        <div className={styles.sectionHeader}>
          <HeadingAndIcon icon={<FaUserPlus />} heading="Assign Student" />
        </div>
        <div className={styles.studentdata}>
          <div className={styles.controls}>
            <SearchBar
              placeholder="Search Student"
              onChange={(e) => setSearch(e.target.value)}
            />
            <Dropdown
              bgColor="var(--Utility_Color9)"
              label="Room"
              options={["Room A", "Room B"]}
            />
          </div>

          <div className={styles.listHeader}>
            <label>
              <input
                type="checkbox"
                checked={selectedStudents.length === filteredStudents.length}
                onChange={(e) =>
                  setSelectedStudents(
                    e.target.checked ? filteredStudents.map((s) => s.id) : []
                  )
                }
              />{" "}
              Select All
            </label>
            <span>{selectedStudents.length} Selected</span>
          </div>

          <div className={styles.grid}>
            {filteredStudents.map((student) => (
              <label key={student.id} className={styles.studentBox}>
                <input
                  type="checkbox"
                  checked={selectedStudents.includes(student.id)}
                  onChange={() => handleCheckboxChange(student.id)}
                />
                <span>{student.name}</span>
              </label>
            ))}
          </div>

          <div className={styles.footerActions}>
            <SaveAndCancel onSave={handleSave} onCancel={handleCancel} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddStudentsToGroup;
